import { useState, useCallback } from "react";

const useConfirm = (): UseConfirmReturn => {
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [onConfirmCallback, setOnConfirmCallback] = useState<ConfirmCallback | null>(null);
    const [onCancelCallback, setOnCancelCallback] = useState<ConfirmCallback | null>(null);

    const confirm = useCallback(
        (msg: string, onConfirm: ConfirmCallback, onCancel?: ConfirmCallback) => {
            setMessage(msg);
            setOnConfirmCallback(() => onConfirm);
            setOnCancelCallback(() => onCancel || null);
            setIsOpen(true);
        },
        []
    );

    const handleConfirm = () => {
        setIsOpen(false);
        onConfirmCallback && onConfirmCallback();
    };

    const handleCancel = () => {
        setIsOpen(false);
        onCancelCallback && onCancelCallback();
    };

    return {
        isOpen,
        message,
        confirm,
        handleConfirm,
        handleCancel,
    };
};

export { useConfirm };